module.exports = "/_next/static/images/omotesando_salad_lunch-3c2d7458f13972c723ec83e50a21c76a.jpg";